import { ALL } from '@/constant';
import { useSalesStatusCountQuery } from '@/generated/graphql-react-query';
import { IReportControl } from '@/types/report/type';

export const useOrderStatusCountHook = ({
  startDate,
  endDate,
  brandId,
  channel,
  gift,
  orderStatus,
  paymentStatus,
  shippingStatus,
  salesCode,
  countryId,
}: IReportControl) => {
  const { data, isLoading } = useSalesStatusCountQuery({
    input: {
      filter: {
        countryId,
        startOrderedAt: startDate,
        endOrderedAt: endDate,
        ...(brandId !== ALL && { brandId }),
        ...(channel !== ALL && { channel }),
        ...(gift !== ALL && { giftType: gift }),
        ...(orderStatus !== ALL && { orderStatus }),
        ...(paymentStatus !== ALL && { paymentStatus: [paymentStatus] }),
        ...(shippingStatus !== ALL && { shippingStatus: [shippingStatus] }),
        ...(salesCode !== ALL && { salesCode: [salesCode] }),
      },
    },
  });

  return {
    data: data?.salesStatusCount || {
      ok: 0,
      cancel: 0,
    },
    isLoading,
  };
};
